// Modules
import React, { CSSProperties } from "react";
// @ts-ignore
import { LocalizationContext } from 'react-localize';

// Styles
import './FilterResults.sass';

// Interfaces
import FilterResult from "Interfaces/FilterResultInterface";
import SelectedFilters from "Interfaces/SelectedFiltersInterface";

// Components
import FilterResultsGroup from "./FilterResultsGroup";
import ResultFilterByHotel from "./ResultFilterByHotel";
import MvCheckBox from "Generic/MvCheckBox/MvCheckBox";
import MvIcon from "Components/Header/MvIcon";

type Props = {
  selectedFilters: SelectedFilters;
  filters: FilterResult;
  onClear: () => void;
  onSortResults: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSelect: (name: string, value: string) => void;
  toggleOpen: (name: string) => void;
  toggleFilter?: () => void;
  disableRoomTypeFilter?: boolean;
  disableViewFilter?: boolean;
  disableActivitiesFilter?: boolean;
  disableAreaFilter?: boolean;
  disableClearFilter?: boolean;
  id?: string
  isAlternateSearchAvailable?:boolean
  sortChecked?: boolean;
  isMobileFilterOpen?: boolean;
  toggleMobileFilter?: () => void;
  checkAvailabilty?: boolean;

};

class FilterResults extends React.Component<Props, {}> {

  constructor(props: Props) {
    super(props);
    this.onSelect = this.onSelect.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this)
    this.clear = this.clear.bind(this);
    this.onSortResults = this.onSortResults.bind(this);
  }
  iconStyle:CSSProperties = {
    position: "absolute",
    top: "15px",
    fill: "white"
  };
  iconClearStyle:CSSProperties = {
    fill: "#008577"
  };
  cleartextStyle:CSSProperties = {
    color: "#008577",
    fontSize: "18px",
    fontWeight: 600,
    fontFamily: "Montserrat",
    lineHeight: "28px",
    wordWrap: "break-word",
  }
  onSelect(name: string, value: string) {
    this.props.onSelect(name, value);
  
  }
  onSortResults(e: React.ChangeEvent<HTMLInputElement>) {
    this.props.onSortResults(e);
  }

  clear() {
    if (this.props.disableClearFilter) return;
    this.props.onClear();
  }
  toggleOpen(name: string) {
    this.props.toggleOpen(name);
  }
  toggleFilter() {
    // let el: any = document.getElementById('html')
    // let box: any = document.getElementById('filter-box');

    // box.classList.toggle("display")
    // el.classList.toggle("overflow")
    if (this.props.toggleMobileFilter) {
      // this.props.toggleFilter();
      this.props.toggleMobileFilter && this.props.toggleMobileFilter();
    }
  }

  render() {
  
    const { localize } = this.context;
    return (
      <React.Fragment>
        <aside className="columns two filter-wrapper" id="filter-box">
          <div className="filter-options-table">
            <div className="filter-options header">
              <div className="filter-header">{localize("static.content.narrow-results")} </div>
              <button className="back-btn" onClick={this.toggleFilter}>
                <MvIcon
                  style={this.iconStyle}
                  height="16px"
                  width="16px"
                  icon={"times"}
                />
              </button>
            </div>
            <ul className="filter-body-wrapper">
              {this.props.isMobileFilterOpen && !this.props.checkAvailabilty && <li className="filter-type">
                <div className="sort-by-location-mob">
                <MvCheckBox
                  label={localize("static.content.sort-by-location")}
                  onChange={this.onSortResults}
                  checked={this.props.sortChecked}
                  id={"sortBy"}
                />
              </div>
              </li> }
              <li className="filter-type">
                <FilterResultsGroup
                  displayName={localize("static.content.room-type")}
                  isAlternateSearchAvailable={this.props.isAlternateSearchAvailable}
                  onSelect={this.onSelect}
                  name="roomType"
                  disabled={this.props.disableRoomTypeFilter || this.props.filters["roomType"].length === 0}
                  items={this.props.filters["roomType"]}
                  selected={this.props.selectedFilters["roomType"].filters}
                  opened={this.props.selectedFilters["roomType"].expanded}
                  toggleOpen={this.toggleOpen} />
              </li>
              <li className="filter-type">
                <FilterResultsGroup
                  displayName={localize("static.content.view")}
                  isAlternateSearchAvailable={this.props.isAlternateSearchAvailable}
                  onSelect={this.onSelect}
                  name="views"
                  disabled={this.props.disableViewFilter || this.props.filters["views"].length === 0}
                  items={this.props.filters["views"]}
                  selected={this.props.selectedFilters["views"].filters}
                  opened={this.props.selectedFilters["views"].expanded}
                  toggleOpen={this.toggleOpen} />
              </li>
              <li className="filter-type">
                <FilterResultsGroup
                  displayName={localize("static.content.activities")}
                  isAlternateSearchAvailable={this.props.isAlternateSearchAvailable}
                  onSelect={this.onSelect}
                  name="activity"
                  disabled={this.props.disableActivitiesFilter || this.props.filters["activities"].length === 0}
                  items={this.props.filters["activities"]}
                  selected={this.props.selectedFilters["activity"].filters}
                  opened={this.props.selectedFilters["activity"].expanded}
                  toggleOpen={this.toggleOpen} />
              </li>
              <li className="filter-type by-hotel">
                <FilterResultsGroup
                  displayName={localize("static.content.area")}
                  isAlternateSearchAvailable={this.props.isAlternateSearchAvailable}
                  name="area"
                  disabled={this.props.disableAreaFilter}
                  opened={this.props.selectedFilters["area"].expanded}
                  toggleOpen={this.toggleOpen}
                >
                  <ResultFilterByHotel
                    selectedCities={this.props.selectedFilters["area"].filters}
                    area={this.props.filters["area"]}
                    onSelect={this.onSelect} />
                </FilterResultsGroup>
              </li>
              <li className="clear-filters">
             { 
               <button onClick={this.clear} className="filter-cancel">
                {<MvIcon
                  style={this.iconClearStyle}
                  height={this.props.isMobileFilterOpen ? "28px" : "15px"}
                  width="15px"
                  icon="times"
               /> }
               <div style={ this.props.isMobileFilterOpen ? this.cleartextStyle : undefined }> {localize("static.content.clear-filters")} </div>
              </button>
  }
            </li>
            </ul>
            
          </div>
        </aside>
      </React.Fragment>
    );
  }
}

FilterResults.contextType = LocalizationContext;

export default FilterResults;
